import React from 'react';

const TenantAuthPolicyFormModal = React.lazy(() => import('../components/FormModal'));
const tenantAuthPolicyModalRegistry = {
    core_tenantAuthPolicyId: TenantAuthPolicyFormModal
};
export default tenantAuthPolicyModalRegistry;
